module.exports = __webpack_public_path__ + "static/brene-brown-9b83582a35b6573ef876a47836100cf7.jpg";